var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0 d-flex flex-column align-center justify-center",class:_vm.$vuetify.theme.dark ? 'background_light' : 'background_normal',staticStyle:{"height":"100vh"},attrs:{"fluid":""}},[_c('admin-login',{staticClass:"mx-auto my-auto"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }